import { PERMISSIONS } from "@/services/permission"

export default [
  {
    path: "/material/list",
    name: "MaterialOverview",
    component: () => import("@/views/material/MaterialOverview"),
    meta: {
      title: "nav.material.overview",
      requiresAuth: true,
      // Either right opens the page: it lists the catalogue's records and its packets, and shows
      // whichever of the two the reader may read (`services/catalogPackets.js`).
      requiresPermissions: [PERMISSIONS.VIEW_MATERIAL_GENERAL, PERMISSIONS.VIEW_PACKET_GENERAL],
    },
  },
  {
    path: "/material/create",
    name: "MaterialCreate",
    component: () => import("@/views/material/MaterialCreate"),
    meta: {
      title: "material.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_MATERIAL_GENERAL],
    },
  },
  {
    path: "/material/:materialId",
    name: "MaterialDetail",
    props: true,
    component: () => import("@/views/material/MaterialDetail"),
    meta: {
      title: "nav.material.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_MATERIAL_GENERAL],
    },
  },
]
